import { render, staticRenderFns } from "./ProductCoupons.vue?vue&type=template&id=405769d5&"
import script from "./ProductCoupons.vue?vue&type=script&lang=ts&"
export * from "./ProductCoupons.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports